import {Component, store, constant} from 'Generic';
import {
  numberFormat,
  getTranslation,
  removeAddon,
  calculateDiscountedAmountAndPercentage,
  calculateTotalOldPrice,
  addCurrencySymbol,
  showCouponResponcse,
  isTrialPlan,
  getPhasePlanDescription,
  isAddonCart,
} from 'Generic/lib';
import {TEAMS} from 'Generic/constants/common';

export default class OrderSummary extends Component {
  constructor() {
    super({
      store,
      state: store.state,
    });
  }

  render() {
    const selectedPlan = this.state.selected_plan ? this.state.selected_plan : {};
    const currencyCode = this.state.currency_code ? this.state.currency_code : 'USD';
    const selectedAddons = this.state.selected_addons ? this.state.selected_addons : [];
    const coupon = this.state.coupon_code || '';
    const adjustment = selectedPlan.adjustment ? {amount: -parseFloat(selectedPlan.adjustment)} : {amount: 0};
    const userCountry = this.state.user_country && this.state.show_vat !== '0' ? this.state.user_country : '';

    this.calculateRecurlyPricing(selectedPlan, currencyCode, selectedAddons, coupon, userCountry, adjustment);
  }

  async calculateRecurlyPricing(selectedPlan, currencyCode, selectedAddons, coupon, userCountry, adjustment) {
    const conversionDriverCheck = cartState?.conversionDriverToggle;
    const {PURE_VPN, DEDICATED_IP, MULTI_LOGIN, RESIDENTIAL_NETWORK_BANDWIDTH, PORT_FORWARDING} = constant;
    const planGroup = JSON.parse(selectedPlan.description || '{}').plan_group;

    const updatedAdjustment = conversionDriverCheck && planGroup !== TEAMS ? {amount: 0} : adjustment;

    const quantityAddonMap = {
      [MULTI_LOGIN]: this.state?.multiLoginQuantity,
      [RESIDENTIAL_NETWORK_BANDWIDTH]: this.state?.residentialNetworknBandwidthQuantity,
    };

    const quantityTeamsAddonMap = {
      [PURE_VPN]: this.state?.teamQuantity,
      [DEDICATED_IP]: this.state?.dedicatedIpsQuantity,
      [RESIDENTIAL_NETWORK_BANDWIDTH]: this.state?.residentialNetworknBandwidthQuantity,
      [PORT_FORWARDING]: this.state?.portFowardingQuantity,
    };

    const checkoutPricing = recurly.Pricing.Checkout();
    const checkoutSubscription = recurly.Pricing.Subscription();

    await checkoutSubscription.plan(this.state?.proplan_code || selectedPlan.code);
    for (const addon of selectedAddons) {
      const quantity = planGroup === TEAMS ? quantityTeamsAddonMap[addon] || 1 : quantityAddonMap[addon] || 1;
      await checkoutSubscription.addon(addon, {quantity}).done();
    }

    checkoutPricing
      .adjustment(updatedAdjustment)
      .currency(currencyCode)
      .tax({country: userCountry})
      .subscription(checkoutSubscription)
      .catch(err => {
        // err.code
      })
      .done(price => {
        checkoutPricing
          .coupon(coupon)
          .catch(err => {
            showCouponResponcse(false);
          })
          .done(price => {
            /* if coupon applied */
            let couponApplied = false;
            if (this.state.coupon_code && checkoutPricing.couponCodes.length) {
              showCouponResponcse(true);
              couponApplied = this.state.coupon_code;
            }

            this.updateOrderSummary(price, selectedPlan, currencyCode, couponApplied);
          });
      });
  }

  updateOrderSummary(totalPriceObject, selectedPlan, currencyCode, couponApplied = false) {
    let {addons, months} = selectedPlan;
    const monthlyOldPrices = this.state.old_prices ? this.state.old_prices : {};

    months = parseInt(this.state.count_extra_month) === 1 ? months : selectedPlan.interval_length;
    const sumRequiredAddonPrice = calculateTotalOldPrice(months, monthlyOldPrices, currencyCode, selectedPlan);

    this.updateTotalPrice(totalPriceObject);
    this.updatePlanSummary(selectedPlan, sumRequiredAddonPrice, totalPriceObject);
    this.updateAddonSummary(addons);
    this.updateSpecialAddonSummary(addons);
    this.updateCouponSummary(totalPriceObject, couponApplied);
    this.updateDiscountSummary(selectedPlan, sumRequiredAddonPrice, totalPriceObject);
    this.updateTrialDescription(selectedPlan);
    this.updateVat(totalPriceObject);
  }

  updatePlanSummary(planObject, oldPrice, totalPriceObject) {
    const {setup_fee: setupFee, per_month: perMonthPrice, months, labels, billing_cycle, interval_length} = planObject;
    const {adjustments: adjustments, items: subscriptionItems} = totalPriceObject.now;
    const planGroup = JSON.parse(planObject.description || '{}').plan_group;
    const {PURE_VPN} = constant;

    const conversionDriverCheck = cartState?.conversionDriverToggle;
    const isBFCMPromoCodeActive = cartState?.isBFCMPromoCodeActive;

    let [{plan: planPrice}] = subscriptionItems;

    if (planGroup === TEAMS) {
      const addon = planObject?.addons.find(addon => addon.code == PURE_VPN);
      const addonPrice = Number(addon.unit_amount) / Number(planObject.interval_length);

      planPrice = Number(addonPrice);
    } else if (isBFCMPromoCodeActive) {
      planPrice = Number(planPrice);
    } else {
      planPrice = Number(planPrice) + Number(adjustments);
    }

    let updatedPlanPrice = planPrice;

    if (!isBFCMPromoCodeActive) {
      updatedPlanPrice = planGroup !== TEAMS ? planPrice + setupFee : planPrice;
    }

    let planPriceOrig = addCurrencySymbol(numberFormat(isTrialPlan() ? setupFee : updatedPlanPrice));

    const paymentPlanElement = document.querySelector('.payment-plan');
    const planNameElement = document.querySelector('.payment-plan .plan-name .plan-name-text');
    const planCycleElement = document.querySelector('.payment-plan .plan-name .plan-name-text-sub');
    const freePlanHeadingElement = document.querySelector('.free-plan-summary');
    const planPriceElement = document.querySelector('.requiredaddons-summary .plan-price');
    const planOrigPriceElement = document.querySelector('.payment-plan .plan-orig-price');

    const teamPlanNameSummary = document.querySelector('.teams-summary-new');
    const teamPlanNameElement = teamPlanNameSummary.querySelector('.team-plan-name');
    const teamPlanPriceElement = teamPlanNameSummary.querySelector('.team-plan-price');

    if (isAddonCart()) {
      paymentPlanElement.style.display = 'none';
      return;
    } else {
      paymentPlanElement.style.display = '';
    }

    let couponCodeValue = document.querySelector('.coupon-code-dynamic-value');
    if (couponCodeValue) {
      couponCodeValue.innerHTML = labels.coupon_code_label ? labels.coupon_code_label : '';
    }

    freePlanHeadingElement.innerHTML =
      labels && labels.order_summary_second_label
        ? `<div class='clearfix'><span class="pull-left">${labels.order_summary_second_label}</span><span class="pull-right">${addCurrencySymbol(
            '0.00',
          )}</span></div>`
        : '';

    // hide if no required addons associated with plans
    document.querySelector('.requiredaddons-summary').style.display = 'none';

    planPriceElement.innerHTML = isTrialPlan() || oldPrice <= planPrice ? '' : addCurrencySymbol(numberFormat(oldPrice));

    planNameElement.innerHTML = this.getPlanTitle(planObject);

    if (planGroup === TEAMS) {
      teamPlanNameSummary.style.display = 'flex';

      const teamQuantity = this.state?.teamQuantity || 0;
      const updatedOldPrice = Number(teamQuantity) * Number(oldPrice);

      planPriceElement.innerHTML = isTrialPlan() || oldPrice <= planPrice ? '' : addCurrencySymbol(numberFormat(updatedOldPrice));

      planOrigPriceElement.innerHTML = `${this.capitalizeFirstLetter(getTranslation(planObject.billing_cycle))}`;
      planOrigPriceElement.classList.remove('cut-line');
      planOrigPriceElement.classList.remove('teams-billing-cycle');

      planCycleElement.innerHTML = '';

      // Teams price calculation
      const addonPureVpn = planObject?.addons.find(addon => addon.code == PURE_VPN);
      const addonUnitAmount = Number(addonPureVpn?.unit_amount);
      const addonTeamPrice = Number(teamQuantity) * Number(addonPureVpn?.unit_amount);

      // For teams discount condition
      let [discountPercentage, discountAmount] = calculateDiscountedAmountAndPercentage(oldPrice, addonUnitAmount);

      planPriceOrig = addCurrencySymbol(numberFormat(isTrialPlan() ? setupFee : addonTeamPrice));

      teamPlanNameElement.innerHTML = `${teamQuantity} x accounts <span class="team-plan-name-sub">(${addCurrencySymbol(
        numberFormat(isTrialPlan() ? setupFee : planPrice),
      )}${planObject?.labels?.per_month_label || '/mo/user'})</span>`;

      if (discountAmount > 0) {
        teamPlanPriceElement.innerHTML = planPriceElement.innerHTML;
        teamPlanPriceElement.classList.add('cut-line');
      } else {
        teamPlanPriceElement.innerHTML = planPriceOrig;
        teamPlanPriceElement.classList.remove('cut-line');
      }
    } else {
      teamPlanNameSummary.style.display = 'none';

      let [discountPercentage, discountAmount] = calculateDiscountedAmountAndPercentage(oldPrice, updatedPlanPrice);

      // Individual tab
      if (discountAmount > 0) {
        planOrigPriceElement.innerHTML = planPriceElement.innerHTML;
        planOrigPriceElement.classList.add('cut-line');
      } else {
        planOrigPriceElement.innerHTML = planPriceOrig;
        planOrigPriceElement.classList.remove('cut-line');
      }

      planCycleElement.innerHTML = `${this.capitalizeFirstLetter(getTranslation(planObject.billing_cycle))} (${addCurrencySymbol(
        numberFormat(perMonthPrice),
      )}/mo)`;
    }

    const orderCycleSwitch = document?.querySelector('.order-cycle-switch');
    if (orderCycleSwitch) {
      // const conversionDriverToggle = this.state.conversionDriverToggle;

      const orderCycleSwitchText = document?.querySelector('.order-cycle-switch-text .plan-duration');
      if (orderCycleSwitchText) {
        const planOne = this.state.plans[0] || {};
        let billingCycle = planOne?.billing_cycle.replace(/ /g, '').toLowerCase();
        billingCycle = getTranslation(billingCycle);
        orderCycleSwitchText.innerHTML = billingCycle;
      }

      const billingCycleCount = Number(this.state.billingCycleCount);
      const isSwitchDisabled = Number(interval_length) >= 12;
      if (planGroup === TEAMS) {
        orderCycleSwitch.setAttribute('switch-plan', 'switch_disabled');
      } else {
        if (isSwitchDisabled || billingCycleCount <= 1) {
          orderCycleSwitch.setAttribute('switch-plan', 'switch_disabled');
        } else {
          orderCycleSwitch.setAttribute('switch-plan', 'switch_enabled');
        }
      }
    }
  }

  updateAddonSummary(planAddons) {
    const planObject = this.state.selected_plan;
    const proplanPackages = this.state.proplan_packages;
    const specialAddonList = constant.specialAddonList;
    const selectedPRoplanPkg = proplanPackages?.[planObject.code]?.[this.state?.proplan_index];

    // For teams addons calculation
    const dedicatedIpsQuantity = this.state.dedicatedIpsQuantity || 1;
    const portFowardingQuantity = this.state.portFowardingQuantity || 1;
    const planGroup = JSON.parse(planObject.description || '{}').plan_group;
    const {PURE_VPN, DEDICATED_IP, PORT_FORWARDING, MULTI_LOGIN, RESIDENTIAL_NETWORK_BANDWIDTH} = constant;

    const addons = (this.state?.proplan_code && selectedPRoplanPkg?.labels?.product_info?.addons) || planAddons;
    let selectedAddons = this.state.selected_addons ? this.state.selected_addons : [];
    selectedAddons = planGroup === TEAMS ? selectedAddons.filter(item => item !== PURE_VPN) : selectedAddons;

    const addonSummaryElement = document.querySelector('.addons-summary');
    let addonSummary = '';
    addonSummary = selectedAddons.reduce((previousValue, currentValue) => {
      const addon = addons.find(addon => {
        return addon.code == currentValue;
      });

      if (addon) {
        if (!specialAddonList.includes(addon.code)) {
          // For teams addons calculation
          const isTeamsDedicatedIp = planGroup === TEAMS && addon?.code === DEDICATED_IP;
          const isTeamsPortForwarding = planGroup === TEAMS && addon?.code === PORT_FORWARDING;

          const quantityPrefix = isTeamsDedicatedIp ? `${dedicatedIpsQuantity} x` : isTeamsPortForwarding ? `${portFowardingQuantity} x` : '';
          const translationKey = isTeamsDedicatedIp ? 'teams_dedicated_ips_v2' : isTeamsPortForwarding ? 'teams_port_forwarding_v2' : addon?.code;
          const addonTitle = `${quantityPrefix} ${getTranslation(translationKey)}`;

          let addonPrice = Number(addon.unit_amount) / Number(planObject.interval_length);
          let unitAmount = addon.unit_amount;
          let quantity = '';

          if (addon.tier_type == 'stairstep') {
            // Find the tier for multi-login
            const multiLoginTier = addon.code === MULTI_LOGIN && addon.tiers.find(item => item.quantity === Number(this.state.multiLoginQuantity));
            // Find the tier for residential bandwidth
            const bandwidthTier =
              addon.code === RESIDENTIAL_NETWORK_BANDWIDTH &&
              addon.tiers.find(item => item.quantity === Number(this.state.residentialNetworknBandwidthQuantity));

            if (multiLoginTier) {
              addonPrice = Number(multiLoginTier.unit_amount) / Number(planObject.interval_length);
              unitAmount = multiLoginTier.unit_amount;
              quantity = `${this.state.multiLoginQuantity} ${getTranslation('logins')}`;
            } else if (bandwidthTier) {
              addonPrice = Number(bandwidthTier.unit_amount) / Number(planObject.interval_length); // Update addonPrice for bandwidth
              unitAmount = bandwidthTier.unit_amount; // Update unitAmount for bandwidth
              quantity = `${this.state.residentialNetworknBandwidthQuantity} ${getTranslation('networks')}`; // Update quantity for bandwidth
            }
          }

          let addonCountry = constant.addonsCountryList[currentValue] ? constant.addonsCountryList[currentValue] : [];
          addonCountry = addonCountry.find(addonCountry => addonCountry.code == this.state.addon_country);

          const updatedUnitAmount = isTeamsDedicatedIp
            ? Number(dedicatedIpsQuantity) * Number(unitAmount)
            : isTeamsPortForwarding
            ? Number(portFowardingQuantity) * Number(unitAmount)
            : unitAmount;

          return (
            previousValue +
            `<div class='clearfix'><span class="pull-left addon-btn" addon-code="${addon.code}">
            <span class="addon-btn-name">${addonTitle}
            <span class='addon-per-month'>(${addCurrencySymbol(numberFormat(addonPrice))}/mo) ${addonCountry ? `- ` + addonCountry.name : ''} ${
              quantity ? `- ` + quantity : ''
            }</span>
            </span>
            <span class="remove-btn cross-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <rect width="11.5679" height="11.5679" rx="5.78394" fill="#E5E7EB"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.72427 3.72607C3.49265 3.9577 3.49264 4.33325 3.72427 4.56488L4.98201 5.82262L3.72472 7.07991C3.49309 7.31154 3.49309 7.68709 3.72472 7.91872C3.95634 8.15034 4.33189 8.15034 4.56352 7.91872L5.82082 6.66142L7.07948 7.92009C7.31111 8.15171 7.68666 8.15171 7.91829 7.92009C8.14991 7.68846 8.14991 7.31291 7.91829 7.08128L6.65962 5.82262L7.91873 4.56351C8.15036 4.33188 8.15036 3.95633 7.91873 3.7247C7.6871 3.49308 7.31155 3.49308 7.07993 3.7247L5.82082 4.98381L4.56308 3.72607C4.33145 3.49445 3.9559 3.49445 3.72427 3.72607Z" fill="#637381"/>
              </svg>
            </span>
            </span>
            <span class="pull-right">${addCurrencySymbol(numberFormat(updatedUnitAmount))}</span></div>`
          );
        }
      } else {
        removeAddon(currentValue);
      }

      return previousValue;
    }, '');

    if (addonSummary) {
      addonSummaryElement.innerHTML = addonSummary;
      addonSummaryElement.style.display = 'flex';
    } else {
      addonSummaryElement.style.display = 'none';
    }
  }

  updateSpecialAddonSummary(planAddons) {
    const planObject = this.state.selected_plan;
    const planType = JSON.parse(planObject.description || '{}')?.plan_type || '';
    const proplanPackages = this.state.proplan_packages;
    const specialAddonList = constant.specialAddonList;
    const selectedPRoplanPkg = proplanPackages?.[planObject.code]?.[this.state?.proplan_index];

    const addons = (this.state?.proplan_code && selectedPRoplanPkg?.labels?.product_info?.addons) || planAddons;
    const selectedAddons = this.state.selected_addons ? this.state.selected_addons : [];

    const specialAddonsSummaryElement = document.querySelector('.specialaddons-summary');
    let specialAddonsSummary = '';

    if (planType == 'vpn_standard') {
      specialAddonsSummary = selectedAddons.reduce((previousValue, currentValue) => {
        let addon = addons.find(addon => {
          return addon.code == currentValue;
        });

        if (addon) {
          if (specialAddonList.includes(addon.code)) {
            let addonPrice = Number(addon.unit_amount) / Number(planObject.interval_length);
            let addonCountry = constant.addonsCountryList[currentValue] ? constant.addonsCountryList[currentValue] : [];
            addonCountry = addonCountry.find(addonCountry => addonCountry.code == this.state.addon_country);

            return (
              previousValue +
              `<div class='clearfix'><p class="sp-addon-name ${addon.name}">${addon.name} ${addonCountry ? `- ` + addonCountry.name : ''}</p>
              <span class="pull-left addon-description"> ${getTranslation(planObject.billing_cycle)} (${addCurrencySymbol(
                numberFormat(addonPrice),
              )}/mo) ${planObject.labels && planObject.labels.extra_months_label ? planObject.labels.extra_months_label : ''}</span>
              <span class="pull-right">${addCurrencySymbol(numberFormat(addon.unit_amount))}</span>
              </div>`
            );
          }
        } else {
          removeAddon(currentValue);
        }

        return previousValue;
      }, '');
    }
    specialAddonsSummaryElement.innerHTML = specialAddonsSummary;
  }

  updateCouponSummary(totalPriceObject, couponApplied) {
    let couponSummary = '';
    const couponSummaryElement = document.querySelector('.coupon-summary');
    const couponHide = this.state.coupon_hide ? this.state.coupon_hide : false;

    const discount = totalPriceObject?.now?.discount;

    if (couponApplied) {
      if (couponHide) {
        couponSummary = `<div class="payment-plan"><span class="pull-left">Coupon applied</span></div>`;
      } else {
        couponSummary = `<div class="payment-plan"><span class="pull-left">Coupon code - ${couponApplied}</span><span class="pull-right coupon-price">-${addCurrencySymbol(
          numberFormat(discount),
        )}</span></div>`;
      }
    }

    couponSummaryElement.innerHTML = couponSummary;
  }

  updateDiscountSummary(planObject, oldPrice, totalPriceObject) {
    const {subtotal: subTotal, adjustments: adjustments, items: subscriptionItems} = totalPriceObject.now;
    let [{plan: planPrice, setupFee}] = subscriptionItems;

    const planGroup = JSON.parse(planObject.description || '{}').plan_group;
    const {PURE_VPN} = constant;

    const conversionDriverCheck = cartState?.conversionDriverToggle;
    const isBFCMPromoCodeActive = cartState?.isBFCMPromoCodeActive;

    const teamQuantity = this.state?.teamQuantity || 0;

    const purevpnAddon = planObject?.addons.find(addon => addon.code === PURE_VPN);

    const planDiscountedPrice = document.querySelector('.plan-discounted-price');
    planDiscountedPrice.innerHTML = '';

    const discountSummaryElement = document.querySelector('.discount-box');
    const discountSummaryNew = document.querySelector('.discount-summary-new');

    const conversionDriverDiscount = document.querySelector('.conversion-driver-summary');
    const cdDiscountBox = conversionDriverDiscount.querySelector('.cd-discount-box');
    const cdDiscountedPrice = conversionDriverDiscount.querySelector('.cd-discounted-price');
    cdDiscountedPrice.innerHTML = '';

    let cdDiscountSummary = '';

    let discountSummary = '';
    let discountPercentage, discountAmount;

    const extraMonthsLabel = this.state.selected_plan?.labels?.extra_months_label
      ? getTranslation(this.state.selected_plan?.labels?.extra_months_label)
      : '';

    const isEligibleForDiscount = () => {
      return !isAddonCart() && !isTrialPlan() && Number(discountAmount) > 0;
    };

    if (planGroup === TEAMS) {
      [discountPercentage, discountAmount] = calculateDiscountedAmountAndPercentage(Number(oldPrice), purevpnAddon?.unit_amount);
    } else {
      let updatedPlanPrice = Number(adjustments) < 0 ? planPrice + Number(adjustments) : planPrice;
      if (isBFCMPromoCodeActive) {
        planPrice = Number(planPrice);
        updatedPlanPrice = planPrice;
      } else {
        planPrice = Number(planPrice) + Number(setupFee);
        updatedPlanPrice = Number(adjustments) < 0 ? planPrice + Number(adjustments) : planPrice;
      }

      [discountPercentage, discountAmount] = calculateDiscountedAmountAndPercentage(Number(oldPrice), updatedPlanPrice);
    }

    if (Number(discountAmount) > 0 && (planGroup === TEAMS || isEligibleForDiscount())) {
      discountSummary = `<span id="discount-label">${getTranslation('save')} ${discountPercentage}%</span>`;
      if (extraMonthsLabel) discountSummary += `<span class="extra-month">${extraMonthsLabel}</span>`;

      let updatedPrice = Number(oldPrice - discountAmount);
      if (planGroup === TEAMS) {
        updatedPrice = Number(oldPrice - discountAmount) * Number(teamQuantity);
      }

      planDiscountedPrice.innerHTML = `<span>${addCurrencySymbol(numberFormat(updatedPrice))}</span>`;
    }

    if (!!discountSummary) {
      discountSummaryElement.innerHTML = discountSummary;
      discountSummaryNew.style.display = 'flex';
    } else {
      discountSummaryNew.style.display = 'none';
    }

    // Conversion Driver Functionality
    if (conversionDriverCheck && planGroup !== TEAMS) {
      const fullAccessLabel = planObject.labels?.full_access_label || '';
      if (fullAccessLabel) {
        cdDiscountSummary = `<span class="bfcm-label">${fullAccessLabel}</span>`;
      }
    }

    if (!!cdDiscountSummary) {
      cdDiscountBox.innerHTML = cdDiscountSummary;
      cdDiscountedPrice.innerHTML = Number(setupFee) > 0 ? `<span>${addCurrencySymbol(numberFormat(setupFee))}</span>` : '';

      conversionDriverDiscount.style.display = 'flex';
    } else {
      conversionDriverDiscount.style.display = 'none';
    }
  }

  updateTotalPrice(price) {
    const planTotalPriceElement = document.querySelector('#payment_total');
    const accordtionOrderTotal = document.querySelector('.accordtion-order-total');

    if (planTotalPriceElement) {
      let taxAmount = '0.00';
      let totalPrice = '0';

      const adjustments = price.now.adjustments;
      const subTotal = price.now.subtotal;

      // custom calculation if adjustment exit
      // beacuse recurly calculating tax before appyling prediscount
      if (price && price.taxes.length && adjustments !== '0.00') {
        taxAmount = Number(price.taxes[0].rate) * subTotal;
        totalPrice = Number(subTotal) + Number(taxAmount);
      } else {
        totalPrice = price.now.total;
      }

      window.total_price = totalPrice;
      accordtionOrderTotal.innerHTML = planTotalPriceElement.innerHTML = addCurrencySymbol(numberFormat(totalPrice));
    }
  }

  updateTrialDescription(planObject) {
    const trialDescriptionElement = document.querySelector('.trial-description-text');
    const trialDescriptionText = planObject.labels?.trial_description_label;
    let trialDescription = '';

    if (isTrialPlan() && trialDescriptionText) trialDescription = this.formatTrialText(planObject, trialDescriptionText);

    trialDescriptionElement.innerHTML = trialDescription;
  }

  updateVat(price) {
    const gatewayTaxSummary = document.querySelector('.tax-summary');
    if (gatewayTaxSummary) {
      const taxPercentageElement = gatewayTaxSummary.querySelector('.text-percentage');
      const taxAmountElement = gatewayTaxSummary.querySelector('.pull-right');

      let taxPercentage = '0';
      let taxAmount = '0.00';

      const subTotal = price.now.subtotal;

      if (price && price.taxes.length) {
        taxAmount = Number(price.taxes[0].rate) * subTotal;
        taxPercentage = Number(price.taxes[0].rate) * 100;
      }

      taxPercentageElement.innerHTML = taxPercentage;
      taxAmountElement.innerHTML = addCurrencySymbol(numberFormat(taxAmount));

      if (Number(taxAmount) > 0) {
        gatewayTaxSummary.classList.remove('with-no-tax');
      } else {
        gatewayTaxSummary.classList.add('with-no-tax');
      }
    }
  }

  formatTrialText(planObject, text) {
    const {unit_amount: unitAmount, interval_length: intervalLength, interval_unit: intervalUnit, trial_length: trialLength} = planObject;
    const trialExpiryDate = new Date(new Date().getTime() + trialLength * 24 * 60 * 60 * 1000);

    return text
      .replace(/%price%/g, `${addCurrencySymbol(unitAmount)}`)
      .replace(/%billingcycle%/g, `${this.getMonthIntervalText(intervalUnit, intervalLength)}`)
      .replace(
        /%date%/g,
        trialExpiryDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        }),
      );
  }

  getPlanTitle(planObject) {
    let {
      interval_length: intervalLength,
      interval_unit: intervalUnit,
      trial_length: trialLength,
      trial_unit: trialUnit,
      display_additional_months: displayAdditionalMonths,
      display_months: displayMonths,
      labels,
    } = planObject;

    /* If order summary first label is available */
    if (labels && labels.order_summary_first_label) return labels.order_summary_first_label;

    /* If trial plan */
    if (isTrialPlan()) {
      const {labels} = planObject;
      return labels.package_plan_label;
    }

    /* If phase plan */
    const phasePlanDecription = getPhasePlanDescription(planObject);
    if (phasePlanDecription) {
      const {phase_interval_unit: phaseIntervalUnit, phase_interval_length: phaseIntervalLength} = phasePlanDecription;
      intervalUnit = phaseIntervalUnit;
      intervalLength = phaseIntervalLength;
    }

    /* If additional months */
    if (displayAdditionalMonths && displayAdditionalMonths > 0 && displayMonths) {
      let display_additional_months_text = displayAdditionalMonths > 1 ? getTranslation('months') : getTranslation('month');

      return `${this.getMonthIntervalText(intervalUnit, displayMonths)} + ${displayAdditionalMonths} ${display_additional_months_text}`;
    }

    return labels?.package_plan_label || planObject?.name;
  }

  getMonthIntervalText(intervalUnit, intervalLength) {
    switch (intervalUnit) {
      case 'days':
        return intervalLength > 1 ? `${intervalLength} ${getTranslation('Days')}` : `${intervalLength} ${getTranslation('Day')}`;
      case 'months':
        return intervalLength > 1 ? `${intervalLength} ${getTranslation('Months')}` : `${intervalLength} ${getTranslation('Month')}`;
      case 'years':
        return intervalLength > 1 ? `${intervalLength} ${getTranslation('Years')}` : `${intervalLength} ${getTranslation('Year')}`;
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
